import React, { useEffect, useState } from 'react';
import { adminService } from '../../services/adminService';
import './Admin.css';

const AdminDashboard = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    adminService.getDashboard()
      .then(res => setStats(res.data))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div>Loading...</div>;

  return (
    <div className="admin-page">
      <h1>Dashboard</h1>
      <div className="admin-stats">
        <div className="admin-stat-card">
          <p className="stat-label">Total Users</p>
          <p className="stat-value">{stats?.total_users || 0}</p>
        </div>
        <div className="admin-stat-card">
          <p className="stat-label">New Users (30d)</p>
          <p className="stat-value">{stats?.new_users_30d || 0}</p>
        </div>
        <div className="admin-stat-card">
          <p className="stat-label">Total Revenue (coins)</p>
          <p className="stat-value">🪙 {(stats?.total_revenue || 0).toFixed(0)}</p>
        </div>
        {stats?.users_by_status && Object.entries(stats.users_by_status).map(([status, count]) => (
          <div className="admin-stat-card" key={status}>
            <p className="stat-label">{status} Users</p>
            <p className="stat-value">{count}</p>
          </div>
        ))}
        {stats?.profiles_by_gender && Object.entries(stats.profiles_by_gender).map(([gender, count]) => (
          <div className="admin-stat-card" key={gender}>
            <p className="stat-label">{gender} Profiles</p>
            <p className="stat-value">{count}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdminDashboard;
